export function BlurView() {
  return (
    <div
      style={{
        backdropFilter: "blur(16px)",
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(255, 255, 255, 0.3)",
      }}
    />
  )
}
